/**
 * a2hsLocal.ts — 홈 화면 추가·알림 안내를 "이 브라우저에서" 닫은 기록(localStorage).
 *
 *  - rmc_a2hs_prompt       설치 안내 닫기 기록 {kind:"never"} | {kind:"later", until}
 *  - rmc_push_prompt_seen  홈 화면 앱 첫 진입 알림 안내를 봤음("1")
 *
 * Safari 와 홈 화면 앱은 저장소가 다르므로 Safari 에서 닫아도 앱에서 알림 안내는 따로 뜬다(의도).
 * 저장소가 막힌 환경(사생활 모드 등)은 조용히 무시 — 매번 안내가 뜰 수 있다.
 */
import { parseA2hsDismiss, type A2hsDismiss } from "@/domain/a2hs";

const A2HS_KEY = "rmc_a2hs_prompt";
const PUSH_SEEN_KEY = "rmc_push_prompt_seen";

function lsGet(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}
function lsSet(key: string, v: string): void {
  try {
    localStorage.setItem(key, v);
  } catch {
    /* 저장소 막힘 */
  }
}

export function readA2hsDismiss(): A2hsDismiss {
  return parseA2hsDismiss(lsGet(A2HS_KEY));
}

export function writeA2hsDismiss(d: Exclude<A2hsDismiss, null>): void {
  lsSet(A2HS_KEY, JSON.stringify(d));
}

export function readPushPromptSeen(): boolean {
  return lsGet(PUSH_SEEN_KEY) === "1";
}

export function writePushPromptSeen(): void {
  lsSet(PUSH_SEEN_KEY, "1");
}
